import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import {
  Icon,
  InfoButton,
  TooltipForElement
} from 'components/common/Elements/Elements';

import classes from './ModalWindow.module.scss';

const ModalWindow = ({
  isOpen = false,
  setIsOpen,
  stylesModal = {},
  children,
  headerText,
  textTooltip
}) => {
  const modalRef = useRef();

  const getFirstLast = () => {
    const focusableModalElements = modalRef.current.querySelectorAll(
      'a[href], button, textarea, input, select'
    );
    const focusableElements = Object.values(focusableModalElements).filter(
      elem => elem.disabled !== true
    );
    return {
      firstElement: focusableElements[0],
      lastElement: focusableElements[focusableElements.length - 1]
    };
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', escFunction);
    } else {
      document.removeEventListener('keydown', escFunction);
    }
    return () => {
      document.removeEventListener('keydown', escFunction);
    };
    // eslint-disable-next-line
  }, [isOpen]);

  const escFunction = e => {
    if (e.code === 'Escape') setIsOpen(false);
    if (e.shiftKey && e.keyCode === 9) {
      const elements = getFirstLast();
      if (document.activeElement === elements.firstElement) {
        elements.lastElement.focus();
        e.preventDefault();
      }
    }
    if (!e.shiftKey && e.keyCode === 9) {
      const elements = getFirstLast();
      if (document.activeElement === elements.lastElement) {
        elements.firstElement.focus();
        e.preventDefault();
      }
    }
  };

  const handleBg = e => {
    if (e.target.id === 'modal') {
      setIsOpen(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div
          className={cn(!stylesModal.bg ? classes.modalBg : stylesModal.bg)}
          id="modal"
          onClick={handleBg}
          role="dialog"
          aria-modal="true"
        >
          <div
            className={cn(classes.modalBody, stylesModal.body)}
            ref={modalRef}
          >
            <>
              <button
                className={classes.exitBtn}
                onClick={() => setIsOpen(false)}
                title="close modal"
              >
                <Icon
                  icon={'Icn_Clear-1'}
                  className={cn(classes.icon, stylesModal.iconClear)}
                />
              </button>
              {headerText && (
                <div className={cn(classes.titleWrap, stylesModal.titleWrap)}>
                  <h2
                    className={cn(
                      classes.title,
                      classes.title_withInfo,
                      stylesModal.title
                    )}
                    size={2}
                  >
                    {headerText}
                  </h2>
                  {textTooltip && (
                    <TooltipForElement
                      text={textTooltip}
                      mode="white"
                      className={classes.info}
                    >
                      <InfoButton />
                    </TooltipForElement>
                  )}
                </div>
              )}
              <div
                className={cn(
                  !stylesModal.children
                    ? classes.children
                    : stylesModal.children
                )}
              >
                {children}
              </div>
            </>
          </div>
        </div>
      )}
    </>
  );
};

ModalWindow.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func.isRequired,
  stylesModal: PropTypes.object,
  children: PropTypes.any,
  headerText: PropTypes.string,
  textTooltip: PropTypes.string
};

export default ModalWindow;
